import * as React from 'react';

export const MOBILE_BREAKPOINT = 768;

export const SHORT_HEIGHT_BREAKPOINT = 700;

export function useIsShortScreen() {
  const [isShort, setIsShort] = React.useState(false);

  React.useEffect(() => {
    if (typeof window.matchMedia !== 'function') {
      setIsShort(window.innerHeight < SHORT_HEIGHT_BREAKPOINT);
      return;
    }

    const mql = window.matchMedia(
      `(max-height: ${SHORT_HEIGHT_BREAKPOINT - 1}px)`,
    );
    const onChange = () => setIsShort(mql.matches);
    mql.addEventListener('change', onChange);
    setIsShort(mql.matches);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isShort;
}

export function useIsMobileResolved(breakpoint = MOBILE_BREAKPOINT) {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(
    undefined,
  );

  React.useEffect(() => {
    if (typeof window.matchMedia !== 'function') {
      setIsMobile(window.innerWidth < breakpoint);
      return;
    }

    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };
    mql.addEventListener('change', onChange);
    setIsMobile(window.innerWidth < breakpoint);
    return () => mql.removeEventListener('change', onChange);
  }, [breakpoint]);

  return isMobile;
}

export function useIsMobile(breakpoint = MOBILE_BREAKPOINT) {
  return !!useIsMobileResolved(breakpoint);
}
